import React, { Component } from 'react'

export class AplicationRight extends Component {
    render() {
        return (
            <div className='aplication__right'>
                <h3 className='aplication__title'>Download our app</h3>
                <p className='aplication__desc'>We're an agtech company with a clear mission: to revolutionize farming by using AI and drone technology.</p>
            </div>
        )
    }
}

export default AplicationRight